module.exports = __webpack_public_path__ + "img/Perforated_Steel2.d6907ab0.jpg";